module.exports = __webpack_public_path__ + "static/media/cy.ee545cf8.svg";